<template>
  <svg width="16px" height="16px"
       viewBox="0 0 16 16" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/16x16/close/black</title>
    <g id="atoms/icons/16x16/close/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M4.70132034,3.28595479 L8.00021356,6.58506157 L11.3009836,3.28595479 C11.6915079,2.8954305 12.3246729,2.8954305 12.7151972,3.28595479 C13.1057215,3.67647908 13.1057215,4.30964406 12.7151972,4.70016835 L9.41521356,7.99906157 L12.7151972,11.2998316 C13.1057215,11.6903559 13.1057215,12.3235209 12.7151972,12.7140452 C12.3246729,13.1045695 11.6915079,13.1045695 11.3009836,12.7140452 L8.00021356,9.41406157 L4.70132034,12.7140452 C4.31079605,13.1045695 3.67763107,13.1045695 3.28710678,12.7140452 C2.89658249,12.3235209 2.89658249,11.6903559 3.28710678,11.2998316 L6.58621356,7.99906157 L3.28710678,4.70016835 C2.89658249,4.30964406 2.89658249,3.67647908 3.28710678,3.28595479 C3.67763107,2.8954305 4.31079605,2.8954305 4.70132034,3.28595479 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
